<template>
  <div class="box animated fadeIn">
    <div class="outline">
      <div class="rightCon">
        <p class="subtitle" v-html="Container.subtitle"></p>

        <div class="HeaderTitle">
          <div v-html="Container.title"></div>
        </div>
        <div v-for="item in Container.list">
          <p class="title">{{ item.title }}</p>
          <p
            v-if="!Array.isArray(item.body)"
            class="text"
            v-html="item.body"
          ></p>
          <div v-else class="text">
            <ul style="list-style-type: decimal;margin-left:20px">
              <li v-for="row in item.body">{{ row }}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="leftCon">
        <div v-if="Type" class="img" :style="Cover"></div>
        <div v-else class="videos">
          <Media
            :kind="'video'"
            :controls="false"
            :src="[
              Container.videosrc != ''
                ? require('../../static/' + Container.videosrc)
                : ''
            ]"
            :autoplay="true"
            :style="{ width: '100%', height: '100%' }"
            :loop="true"
            :ref="'Player'"
          >
          </Media>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Media from "@dongido/vue-viaudio";
export default {
  name: "HelloWorld",
  components: { Media },
  props: {

    Type: Boolean,
    ImgUrl: String,
    Container: Object
  },
  data() {
    return {
      Cover: {
        backgroundImage: "url(" + require("../assets/" + this.ImgUrl) + ")"
      }
    };
  },
  mounted() {},

  methods: {
    goBack() {
      this.$router.push("/Home");
    },
    PlayEvent() {
      this.$refs.Player.play();
    },
    PauseEvent() {
      this.$refs.Player.pause();
    }
  }
};
</script>

<style scoped lang="scss">
.subtitle {
  font-size: 1.5rem;
}
.HeaderTitle {
  line-height: 3rem;
  display: flex;
  justify-content: space-between;
  font-size: 2rem;
  border-bottom: 1px solid #fff;
  margin-bottom: 30px;
  padding-bottom: 20px;
}
.dvline {
  height: 1px;
  background-color: aliceblue;
  margin: 20px;
}
.title {
  font-size: 1.6rem;
}
.text {
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
  line-height: 2.6rem;
  font-weight: 400;
  text-align: justify;
}

.img {
  width: 100%;
  height: 100%;
  /*position: relative;*/
  background-color: #999999;
  /*background-size: 100%;*/
}

.leftCon {
  width: 63%;
  height: 100%;
}

.rightCon {
  color: #fff;
  text-align: left;
  padding: 60px;
  float: right;
  width: 37%;
  height: 100%;
  background-color: #555555;
}

.outline {
  /*background-color: blueviolet;*/
  height: 100%;
}

.box {
  /*position: absolute;*/
  /*background-color: black;*/
  padding: 120px 60px 50px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  height: 100%;
}

.videos {
  width: 100%;
  height: 100%;
  background-color: black;
}
</style>
